import { makeStyles } from "@material-ui/core/styles";

// D8.5.1 — Estilos de Settings/Options (extraídos del god file).
export const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  // ✅ CORREGIDO: Card dinámico según tema - Más compacto
  sectionCard: {
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.mode === 'dark' 
      ? '0 2px 8px rgba(0,0,0,0.3)' 
      : '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: theme.mode === 'dark' 
        ? '0 4px 16px rgba(0,0,0,0.5)' 
        : '0 4px 16px rgba(0,0,0,0.15)',
      transform: 'translateY(-2px)',
    },
  },
  // ✅ CORREGIDO: Header dinámico - mantener gradiente azul pero adaptable
  sectionHeader: {
    background: theme.mode === 'dark' 
      ? 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)' 
      : 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
    color: 'white',
    padding: theme.spacing(2),
    borderRadius: '12px 12px 0 0',
    marginBottom: 0,
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 600,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  sectionContent: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: SettingItem dinámico según tema - Más compacto
  settingItem: {
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderRadius: 8,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e9ecef'}`,
    transition: 'all 0.2s ease',
    height: '100%',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e3f2fd',
      borderColor: theme.mode === 'dark' ? theme.palette.primary.light : '#1976d2',
    },
  },
  // ✅ CORREGIDO: Labels dinámicos según tema - Más compactos
  settingLabel: {
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    display: 'block',
  },
  settingDescription: {
    fontSize: '11px',
    color: theme.palette.text.secondary || theme.palette.text.primary,
    marginBottom: theme.spacing(1),
    fontStyle: 'italic',
    lineHeight: 1.4,
  },
  // ✅ CORREGIDO: FormControl dinámico según tema
  formControl: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      '& fieldset': {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      fontWeight: 500,
      color: theme.palette.text.secondary || theme.palette.text.primary,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiSelect-root': {
      color: theme.palette.text.primary,
      fontSize: '13px',
      padding: theme.spacing(1.2, 1.4),
    },
    '& .MuiMenuItem-root': {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      },
    },
  },
  statusChip: {
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: 16,
    height: 24,
  },
  statusEnabled: {
    backgroundColor: theme.mode === 'dark' ? '#1f4a1f' : '#e8f5e8',
    color: theme.mode === 'dark' ? '#4ade80' : '#2e7d32',
  },
  statusDisabled: {
    backgroundColor: theme.mode === 'dark' ? '#4a1f1f' : '#ffebee',
    color: theme.mode === 'dark' ? '#f87171' : '#c62828',
  },
  // ✅ CORREGIDO: Divider dinámico según tema
  divider: {
    margin: theme.spacing(2, 0),
    backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
  },
  // ✅ Estilos para TextField en modo dark
  textFieldInput: {
    backgroundColor: theme.mode === 'dark' ? '#374151' : 'transparent',
    color: theme.palette.text.primary,
    '& .MuiOutlinedInput-input': {
      color: theme.palette.text.primary,
    },
  },
  textFieldLabel: {
    color: theme.palette.text.secondary || theme.palette.text.primary,
  },
  loadingText: {
    fontSize: '12px',
    color: theme.palette.primary.main,
    fontStyle: 'italic',
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      color: theme.palette.text.primary,
      '& fieldset': {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiFormHelperText-root': {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
}));
